import axios from 'axios';

const BASE_URL = '/app/authoring';

export const getActionDescription = async (actionSetId) => {
    const { data } = await axios.get(`${BASE_URL}/actionSet/${actionSetId}/desc`);

    return data;
};

export const getAllActionSet = async () => {
    const { data } = await axios.get(`${BASE_URL}/allActionSet`);

    return data;
};
